<template>
    <div class="qualityenterprise whitebox" style="height: 100vh;" v-title :data-title="title">
        <leftnav class="fl" mkcode="B" itemcode="B-HYJHK"></leftnav>
        <div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
            <govheader></govheader>
            <el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="20vh">
                <freeUserTips :type="4" :bgtype="0"></freeUserTips>
            </el-dialog>
            <div class="whitebox right_topbox">
                <div class="right_boxtitle">
                    <span class="fl right_title">行业机会库</span>
                    <!-- <span class="fl dib py-1 ml-5 orgfont">全库 1000+份 深度行业研究报告，研究行业再也不用自己查找整合资料，直接看就行！省时！省力！</span> -->
                    <div class="fr search-box nz-search-box">
                        <span class="searchtype">行业机会库</span>
                        <input type="text" placeholder="请输入行业关键词" class="search-input" v-model="searchtext"
                            @keydown="searchenter" />
                        <button class="search-btn" @click="searchkwfun">查询</button>
                    </div>
                </div>
                <div class="opport-screen-list1">
                    <dl class="opport-screen bdbe">
                        <dt class="fl">一级行业</dt>
                        <dd class="fl">
                            <span :class="industryValue == 0 ? 'a-screen current' : 'a-screen'"
                                @click="chooseIndutry({ paraValue: 0, paraName: '全部' }, 1)">全部</span>

                            <span :class="industryValue == list.value ? 'a-screen current' : 'a-screen'"
                                @click="chooseFuture(list, 1)" :key="'future' + i" v-for="(list, i) in futureList">{{
                                list.name }}</span>
                            <span :class="industryValue == list.paraValue ? 'a-screen current' : 'a-screen'"
                                @click="chooseIndutry(list, 1)" :key="i" v-for="(list, i) in industryList">{{
                                list.paraName }}</span>
                        </dd>
                    </dl>
                    <dl class="opport-screen bdbe" v-show="industryList2.length > 0">
                        <dt class="fl">二级行业</dt>
                        <dd class="fl">
                            <span :class="industryValue2 == 0 ? 'a-screen current' : 'a-screen'"
                                v-show="industryValue != 'w0'"
                                @click="chooseIndutry({ paraValue: 0, paraName: '全部' }, 2)">全部</span>
                            <span :class="industryValue2 == list.paraValue ? 'a-screen current' : 'a-screen'"
                                v-show="industryValue != 'w0'" @click="chooseIndutry(list, 2)" :key="i"
                                v-for="(list, i) in industryList2">{{
                                list.paraName }}</span>
                            <span :class="industryValue2 == list.value ? 'a-screen current' : 'a-screen'"
                                v-show="industryValue == 'w0'" @click="chooseFuture(list, 2)" :key="'future_' + i"
                                v-for="(list, i) in industryList2">{{
                                list.name }}</span>
                        </dd>
                    </dl>
                </div>
            </div>

            <div class="investment-opportunity-table">
                <el-table :data="tableData" border style="width: 100%">
                    <el-table-column label="投资机会点">
                        <template slot-scope="scope">
                            <span class="curp" @click="routerblank('/tradeDetail?id='+scope.row.id)">{{ scope.row.title
                                }}</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="一级行业">
                        <template slot-scope="scope">
                            <span>{{ scope.row.industry1Text }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="二级行业">
                        <template slot-scope="scope">
                            <span>{{ scope.row.industry2Text }}</span>
                        </template>
                    </el-table-column> -->
                    <el-table-column label="投资机会大小">
                        <el-table-column label="市场空间">
                            <template slot-scope="scope">
                                <span>{{ scope.row.marketRequirement }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="技术进步">
                            <template slot-scope="scope">
                                <span>{{ scope.row.techCompete }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="政策支持">
                            <template slot-scope="scope">
                                <span>{{ scope.row.policySupport }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="综合" class-name="zonghe-opportunity">
                            <template slot-scope="scope">
                                <span>{{ scope.row.investChanceScore }}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="进入是否容易">
                        <el-table-column label="竞争格局">
                            <template slot-scope="scope">
                                <span>{{ scope.row.industryCompete }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="盈利水平">
                            <template slot-scope="scope">
                                <span>{{ scope.row.industryProfit }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="进入门槛">
                            <template slot-scope="scope">
                                <span>{{ scope.row.entryThreshold }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="综合" class-name="zonghe-strategy">
                            <template slot-scope="scope">
                                <span>{{ scope.row.entryEasyScore }}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="投资时机好坏">
                        <el-table-column label="行业阶段">
                            <template slot-scope="scope">
                                <span>{{ scope.row.developStage }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="技术进步">
                            <template slot-scope="scope">
                                <span>{{ scope.row.techStage }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="资本支持">
                            <template slot-scope="scope">
                                <span>{{ scope.row.capitalSupport }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="综合" class-name="zonghe-risk">
                            <template slot-scope="scope">
                                <span>{{ scope.row.investChanceScore }}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>

import { mapState, mapMutations, mapGetters } from "vuex";
export default {
    name: "investmentOpportunity",
    computed: {
        ...mapState({
            isCollapse: (state) => state.isCollapse,
        }),
        ...mapGetters(['isCollapse']),

    },
    data() {
        return {
            title: '行业机会库',
            tableData: [
                {
                    investmentPoint: '工业机器人',
                    primaryIndustry: 'B',
                    secondaryIndustry: 'C',
                    marketDemand: 'D',
                    technicalProgress: 'E',
                    opportunityComposite: 'F',
                    entryBarrier: 'G',
                    industryRisk: 'H',
                    riskComposite: 'I',
                    resourceMatch: 'J',
                    capabilityMatch: 'K',
                    strategyComposite: 'L'
                },
            ],
            curWebsite: this.$api.getWebsiteType(),
            userdata: {},
            reportList: [],
            industryList: [],
            industryList2: [],
            industryValue: 0,
            industryValue2: 0,
            page: 1, //显示的是哪一页
            haspage: true, //是否还有下一页
            pageSize: 10, //每一页显示的数据条数
            total: 0, //记录总数
            totalPage: 1,
            maxPage: 10, //最大页数 
            isShowFreeUserTips: false,
            yj_itemcode: 'R-BGQK',
            biglist: [{
                name: "未来产业",
                value: 'w0',
                itemcode: "R-WLCY",
            },
            {
                name: "数字经济",
                value: 10005,
                itemcode: "R-SZJJ",
            },
            {
                name: "高端制造",
                value: 10014,
                itemcode: "R-GDZZ",
            },
            {
                name: "能源环保材料",
                value: 10024,
                itemcode: "R-NYHBCL",
            },
            {
                name: "现代服务业",
                value: 10018,
                itemcode: "R-XDFWY",
            },
            {
                name: "大消费",
                value: 10029,
                itemcode: "R-DXF",
            },

            {
                name: "基建与投资",
                value: 10034,
                itemcode: "R-JJYTZ",
            },
            {
                name: "大健康",
                value: 10001,
                itemcode: "R-DJK",
            },
            {
                name: "报告全库",
                value: 0,
                itemcode: "R-BGQK",
            },
            {
                name: "月度报告",
                value: 10055,
                itemcode: "R-YDBG",
            },

            ],
            futureList: [],
            kwtextsearchtext: "",
            searchtext: "",
        };
    },
    created() {
        // this.fetchData();
    },
    mounted() {
        this.userdata = this.getuseriformation();
        this.getparameterList(0);
        this.getList();
    },
    methods: {
        getList(pages, type) {
            var _this = this;
            this.page = pages ? pages : 1;
            this.bus.$emit('loading', true);
            let searchKw = this.splicing('kw', this.searchtext);
            let industry1 = this.splicing('industry1', this.industryValue);
            let industry2 = this.splicing('industry2', this.industryValue2);
            var ajaxurl = this.$api.common.analyse.list() + '?page=1' + industry1 + industry2 + searchKw;
            this.$axios.get(ajaxurl).then(function (res) {
                if (res.data.success) {
                    console.log('列表', res, ajaxurl);
                    _this.tableData = res.data.list;
                    _this.totalPage = res.data.totalPage;
                    _this.pageSize = res.data.pageSize;
                    _this.total = res.data.totalRecord;
                    _this.bus.$emit('loading', false);
                } else {

                }
            }).catch(function (error) {
                _this.bus.$emit('loading', false);
                // 请求失败处理 console.log(error);
            });
        },
        chooseFuture(list, step) {
            console.log(list, step);
            if (step == 1) {
                // this.yj_itemcode = list.itemcode;
                this.industryValue = list.value;
                this.industryList2 = list.children;
                this.chooseFuture(list.children[0], 2);
                // document.title = list.name;
            } else {
                console.log(list.reportList);
                this.industryValue2 = list.value;
                // this.tableData = list.reportList;
            }
            this.getList();
            this.total = this.reportList.length;
            // console.log(this.industryList2,this.industryValue);
        },
        //获取未来产业参数及列表，参数用的列表里面的一级name
        getFutureList() {
            var _this = this;
            var ajaxurl = this.$api.cyl.report.futureIndustry();
            this.bus.$emit('loading', true);
            this.$axios.get(ajaxurl).then(function (res) {
                if (res.data.success) {
                    let data = res.data.list;
                    let list = { name: '未来产业', value: 'w0', itemcode: 'R-WLCY', children: data };
                    _this.futureList.push(list);
                    console.log('未来产业', _this.futureList);
                    if (_this.industryValue == 'w0') {
                        _this.chooseFuture(list, 1);

                    }
                    _this.bus.$emit('loading', false);
                } else {

                }
            }).catch(function (error) {
                // 请求失败处理 console.log(error);
            });
        },
        chooseIndutry(list, step) {
            if (step == 1) {
                if (list.paraValue == 0) {
                    this.industryValue = 0;
                    this.industryValue2 = 0;
                    this.industryList2 = [];
                    console.log(list);
                } else {
                    this.industryValue = list.paraValue;
                    this.industryList2 = list.children;
                    this.industryValue2 = '';
                }
            } else if (step == 2) {
                // if (!this.userdata.token) {
                // 	this.isShowFreeUserTips = true;
                // 	return;
                // }
                console.log(2, list);
                this.industryValue2 = list.paraValue;
            }
            this.searchtext = '';
            this.getList();
        },
        getparameterList(value) {
            var _this = this;
            console.log(this.$api.cyl)
            var ajaxurl = this.$api.cyl.report.industryList();

            this.$axios.get(ajaxurl).then(function (res) {
                if (res.data.success) {
                    console.log('行业参数', res);
                    let industry = res.data.list;
                    // 根据 biglist 中的 name 顺序，重新排列 industry,Sam说要按照左侧菜单栏排序
                    const sortedList = _this.biglist.map(item => {
                        return industry.find(node => node.paraName === item.name);
                    }).filter(item => item !== undefined);
                    _this.industryList = sortedList;
                    console.log('排序后', sortedList);
                    _this.getFutureList();

                } else {

                }
            }).catch(function (error) {
                // 请求失败处理 console.log(error);
            });
        },
        //搜索关键词
        searchkwfun() {
            this.searchtext = $.trim(this.searchtext);
            if (this.searchtext.length > 0) {
                this.kwtextsearchtext = this.searchtext;
                this.getList(1, 'search');
            } else {
                this.$message({
                    type: 'error',
                    message: '请输入关键词搜索',
                });
            }
        },
        searchenter(e) {
            if (e.keyCode == 13) {
                this.searchkwfun();
            }
        },
        pageHandler: function (page) {
            this.getList(page);
        },
    }
};
</script>

<style lang="scss">
.investment-opportunity-table {
    margin: 20px;
}
.el-table td .cell{
    text-align: center;
}

.el-table thead.is-group th.el-table__cell {
    background: #f3f7ff !important;
    color: #333;
    font-size: 16px;
    text-align: center;
}

.investment-opportunity-table {
    margin: 20px;
}

.el-table thead.is-group th.el-table__cell {
    background: #f3f7ff !important;
    color: #333;
    font-size: 16px;
    text-align: center;
}

.zonghe-opportunity {
    background: #f3f7ff !important;
    /* 投资机会大小的综合 */
}

.zonghe-risk {
    background: #f3f7ff !important;
    /* 机会与风险权衡的综合 */
}

.zonghe-strategy {
    background: #f3f7ff !important;
    /* 战略匹配的综合 */
}
</style>